import type { KeyboardProfile } from './types'

/**
 * Keyboard profile - treats keyboard as a virtual controller.
 */
export const keyboardProfile: KeyboardProfile = {
  id: 'keyboard',
  name: 'Keyboard',
  buttons: {
    select: 'Enter',
    exit: 'Escape',
    configure: 'X',
    menu: 'M',
    // NOTE: Backtick (`) is reserved for app-level shortcuts (cycling test mates).
    rightBumper: ']',  // Right bumper equivalent
  },
  axes: null,
  dpad: {
    up: 'ArrowUp',
    down: 'ArrowDown',
    left: 'ArrowLeft',
    right: 'ArrowRight',
  },
  deadzone: 0,
}
